import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { AdditionalInfoPopup } from '../popup/additional-info/additional-info.popup';
import { LanguageTranslatePopup } from '../popup/language-translate/language-translate.popup';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent, MatDialog } from '@angular/material';
import { MenuTitleDescriptionModel } from '../../models/menu-title-description.model';
import { MenuItemBulletListModel } from '../../models/menu-item-bullet-list.model';
import { MenuTagModel } from '../../models/menu-tag.model';
import { ItemService } from '../../../provider/item.service';
import { Subscription } from 'rxjs';
import { TranslateModel } from '../../../core/_base/layout/models/translate.model';
import { TranslationService } from '../../../provider/translation.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { AWSService } from '../../../provider/aws.service';
import { AWSS3Image } from '../../models/AWSS3Image.model';
import { UserService } from '../../../provider/user.service';
import { HttpClient } from '@angular/common/http';
import { SurveyHeaderService } from '../../../provider/survey-header.service';
import { Router } from '@angular/router';
import { CatalogueService } from 'src/app/provider/catalogue.service';
import { environment } from '../../../../environments/environment';
import { UserModel } from '../../models/user.model';
import { MenuItemModel } from '../../models/menu-item.model';
import { HomePageDesignerModel } from '../../models/home-page-designer.model';
import { HomePageDesignerService } from '../../../provider/home-page-designer.service';
import * as dayjs from 'dayjs';


interface Marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
}

@Component({
  selector: 'c-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnChanges, OnDestroy {
  constructor(
    public dialog: MatDialog,
    public itemService: ItemService,
    public catalog: CatalogueService,
    public tra: TranslationService,
    public awsService: AWSService,
    public userService: UserService,
    private httpClient: HttpClient,
    public survey: SurveyHeaderService,
    public router: Router,
    private changeDetect: ChangeDetectorRef
  ) {
  }

  @Input() ID: number;

  currentMenuTitleDescriptionModel: MenuTitleDescriptionModel;
  currentMenuItemBulletList: MenuItemBulletListModel;

  subs: Subscription[] = [];
  // Tag Field Start
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  // Enter, comma
  separatorKeysCodes = [ENTER, COMMA];
  // Tag Field End

  // Map Field Start
  zoom = 19;
  marker: Marker;
  language = 'tr';

  // Map Field End

  minPoint = 0;
  maxPoint = 0;

  // i = index of TitleAndDesc array
  cssRate = 3.5;

  // i = index of TitleAndDesc array
  result: number;

  // i = index of BulletList array
  popupVisible = false;

  // Open Language translate popup
  loading = false;

  // Open Additional info popup
  confirmPopup = false;

  // Notify Users Array
  notifyUsers: { name: string; mail: string; id: number; }[] = [];
  allUsers: UserModel[] = [];

  // Start & End dates variable
  startDate: any = null;
  endDate: any = null;

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    this.itemService.getData(this.ID, 'menu-item');
    this.userService.getUsers();
    this.catalog.getData(this.ID);
    this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Items', this.ID);
    this.survey.GETChartResult('itemId', this.ID);
    this.survey.GETChartDateAvg('itemId', this.ID);

    this.allUsers = await this.userService.getUsersPromise() as UserModel[];

    this.itemService.record_change$.subscribe(async (resp) => {

      try {
        this.startDate = dayjs(resp.start_date).format('YYYY-MM-DD');
        this.endDate = dayjs(resp.end_date).format('YYYY-MM-DD');
      } catch {
        this.startDate = dayjs(new Date()).format('YYYY-MM-DD');
        this.endDate = dayjs(new Date()).format('YYYY-MM-DD');
      }
      this.changeDetect.detectChanges();

      if (resp.user_ids_for_notifications && resp.user_ids_for_notifications.split(';')
        && resp.user_ids_for_notifications.split(';').length > 0) {
        this.notifyUsers = [];
        for (const id of resp.user_ids_for_notifications.split(';')) {
          if (id !== 'undefined' && id) {
            const USER = this.allUsers.find(x => x.id === Number(id));
            console.log(USER);
            this.notifyUsers.push({
              id: USER.id,
              mail: USER.email,
              name: `${USER.name} ${USER.last_name}`
            });
          }
        }

        console.log(this.notifyUsers);
      }
    });
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  addTags(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    const data = this.itemService.record_change$.getValue();
    if ((value || '').trim()) {
      this.itemService.postTagData(new MenuTagModel(0, 'menu-item', data.id, value.trim()));
    }
    if (input) {
      input.value = '';
    }
  }

  removeTags(i: number) {
    const tags = this.itemService.tag_change$.getValue();
    this.itemService.deleteTagData(tags[i].id);
    tags.splice(i, 1);
  }

  openDialog() {
    const data = this.itemService.record_change$.getValue();
    const dialogRef = this.dialog.open(AdditionalInfoPopup, { width: '700px', data });
    dialogRef.afterClosed().subscribe(() => {
      this.itemService.getData(this.ID, 'menu-item');
    });
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuTitleDescription') {
      this.currentMenuTitleDescriptionModel = baseData;
    } else {
      this.currentMenuTitleDescriptionModel = undefined;
    }

    if (baseDataType == 'MenuItemBulletList') {
      this.currentMenuItemBulletList = baseData;
    } else {
      this.currentMenuItemBulletList = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      // TODO: Control et
      const data = this.itemService.record_change$.getValue();
      this.itemService.putItem(data);
      if (this.currentMenuTitleDescriptionModel != undefined) {
        this.itemService.putTitleDesData(this.currentMenuTitleDescriptionModel);
      }
      if (this.currentMenuItemBulletList != undefined) {
        this.itemService.putBulletListData(this.currentMenuItemBulletList);
      }
    });

  }

  deleteBullet(item: MenuItemBulletListModel) {
    this.itemService.deleteBulletListData(item.id);
  }

  addBullet() {
    this.itemService.postBulletListData(new MenuItemBulletListModel());
  }

  deleteTitleAndDescImg(i: number) {
    const titleDesc = this.itemService.titleDescription_change$.getValue();
    titleDesc[i].image_url = '';
    this.itemService.deleteFileonAWS(titleDesc[i]);
    this.itemService.putTitleDesData(titleDesc[i]);
  }

  deleteTitleAndDesc(item: MenuTitleDescriptionModel) {
    this.itemService.deleteTitleDesData(item);
  }

  addTitleAndDesc() {
    const item = new MenuTitleDescriptionModel();
    item.menu_item_id = this.ID;
    item.hotel_id = +JSON.parse(localStorage.getItem('token_form')).app_hotel_id;
    this.itemService.postTitleDesData(item);
  }

  deleteImage(i: number, item: AWSS3Image) {
    const images = this.awsService.image_change$.getValue();
    if (i == 0) {
      const data = this.itemService.record_change$.getValue();
      data.image_url = images[1].url.split('?')[0];
      this.itemService.putItem(data);
    }
    images.splice(i, 1);
    this.awsService.deleteImage(this.userService.record_change$.getValue().app_hotel_id, 'Items', item.file_name).subscribe();
  }

  imgUploadClick() {
    document.getElementById('file1').click();
  }

  uploadFile(event: any) {
    let imageName = '';
    let priority;
    if (this.awsService.image_change$.getValue().length > 0) {
      priority = +this.awsService.image_change$.getValue()[this.awsService.image_change$.getValue().length - 1].file_name.split('_')[1].split('.')[0];
      console.log(priority);
    } else {
      priority = 0;
    }
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const format = file.type.split('/')[1];
          priority++;
          imageName = this.ID.toString() + '_' + priority.toString() + '.' + format;
          this.awsService.uploadImage(file, this.userService.record_change$.getValue().app_hotel_id, 'Items', imageName).subscribe(
            (resp: any) => {
              if (priority == 1) {
                const data = this.itemService.record_change$.getValue();
                data.image_url = resp.link;
                this.itemService.putItem(data);
              }
              console.log(resp);
            }, (err) => {
              console.log(err);
            },
            () => {
              this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Items', this.ID);
            }
          );
        };
      }
    }
  }

  uploadTitleFile(event: any, item: MenuTitleDescriptionModel) {
    const selectedFile = event.target.files[0] as File;
    this.itemService.postFile(selectedFile, 'titleDesc', item);
  }

  markerDragEnd(m: Marker, $event: any) {
    const data = this.itemService.record_change$.getValue();
    data.map_location = $event.coords.lat + ',' + $event.coords.lng;
    this.itemService.putItem(data);
  }

  onChange() {
    const data = this.itemService.record_change$.getValue();
    this.itemService.putItem(data);
  }

  drop(event: CdkDragDrop<string[]>, items: AWSS3Image[]) {
    const currentIndex = event.currentIndex;
    const previousIndex = event.previousIndex;
    if (currentIndex == previousIndex) {
      return;
    }

    this.httpClient.post(environment.baseURL + '/v2/api' + '/change_images/' + currentIndex + '/' + previousIndex, items).subscribe(
      () => {
        this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Items', this.ID);
      },
      (err) => console.log(err)
    );
  }

  goDetail() {
    this.loading = true;
    this.popupVisible = true;
    this.survey.GETResultResearchWithProfiles('itemId', this.ID);
  }

  goProfile(profile_id: any) {
    this.router.navigateByUrl('/activity/profile/' + profile_id);
  }

  resetResult() {
    this.survey.deleteResult('itemId', this.ID);
    this.confirmPopup = !this.confirmPopup;
  }

  openConfirmPopup() {
    this.confirmPopup = !this.confirmPopup;
  }

  onTestChange(event, data) {
    if (event.keyCode === 13) {
      data.description = data.description + '\n';
    }
  }

  pushNotifyUser(id: any) {
    const USER = this.userService.users_change$.getValue().find(x => x.id === Number(id));
    this.notifyUsers.push({
      id: USER.id,
      mail: USER.email,
      name: `${USER.name} ${USER.last_name}`
    });
    let users = '';

    for (const [index, user] of this.notifyUsers.entries()) {
      users += user.id;
      if (index < this.notifyUsers.length - 1) {
        users += ';';
      }
    }
    this.itemService.record_change$.getValue().user_ids_for_notifications = users;

    this.itemService.putData(this.itemService.record_change$.getValue());
  }

  deleteNotifyUser(id: any) {
    this.notifyUsers = this.notifyUsers.filter(x => x.id != id);

    let users = '';

    for (const [index, user] of this.notifyUsers.entries()) {
      users += user.id;
      if (index < this.notifyUsers.length - 1) {
        users += ';';
      }
    }

    this.itemService.record_change$.getValue().user_ids_for_notifications = users;

    this.itemService.putData(this.itemService.record_change$.getValue());
  }
  
  updateDate(value: string, key: string) {
    this.itemService.record_change$.getValue()[key] = new Date(value);
    this.itemService.putData(this.itemService.record_change$.getValue());
  }
}
